import { howItWorks } from "../content/homepage"
import useIsMobile from "../hooks/useIsMobile"

export default function HowItWorks() {
    const isMobile = useIsMobile()

    return (
        <section id="how" style={{ background: "#F9FAFB", padding: isMobile ? "64px 20px" : "100px 24px" }}>
            <div style={{ maxWidth: 1280, margin: "0 auto" }}>
                <h2 style={{ fontSize: isMobile ? 32 : 56, marginBottom: 12, letterSpacing: "-0.04em" }}>
                    {howItWorks.heading}
                </h2>
                <p style={{ fontSize: isMobile ? 17 : 20, color: "#6B7280", marginBottom: isMobile ? 40 : 64 }}>
                    {howItWorks.subheading}
                </p>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: isMobile ? 32 : 40 }}>
                    {howItWorks.steps.map((step) => (
                        <div key={step.number}>
                            <div style={{
                                fontSize: isMobile ? 36 : 48, fontWeight: 800, color: "#E5E7EB",
                                marginBottom: 12, letterSpacing: "-0.04em",
                            }}>
                                {step.number}
                            </div>
                            <h3 style={{ fontSize: isMobile ? 20 : 26, fontWeight: 700, margin: "0 0 10px" }}>
                                {step.title}
                            </h3>
                            <p style={{ color: "#6B7280", fontSize: isMobile ? 16 : 18, lineHeight: 1.75, margin: 0 }}>
                                {step.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
